import { atom } from 'jotai';

/**
 * Atom for controlling the upload failure modal.
 * Using an atom (instead of local state) means the data survives navigation —
 * CreateLotForm can navigate immediately to EditLotForm and the toast button
 * will still open the modal after the component unmounts.
 */
export const uploadFailureModalAtom = atom<{
    failureFiles: string[];
    lotNumber: string;
    show: boolean;
}>({ failureFiles: [], lotNumber: '', show: false });
